import { render, staticRenderFns } from "./MyEmbed.vue?vue&type=template&id=4186e624"
import script from "./MyEmbed.vue?vue&type=script&lang=js"
export * from "./MyEmbed.vue?vue&type=script&lang=js"
import style0 from "./MyEmbed.vue?vue&type=style&index=0&id=4186e624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports